import $ from 'jquery';
// eslint-disable-next-line no-unused-vars
import select2 from 'select2';
import mobile from 'is-mobile';
// eslint-disable-next-line no-unused-vars
import daterangepicker from 'daterangepicker';

export default {
  init() {
    if (!mobile()) {
      $('input[name="start-date"], input[name="end-date"]')
        .attr('type', 'text')
        .daterangepicker({
          'singleDatePicker': true,
          'opens': 'center',
          'minDate': new Date(Date.now()),
          'locale': {
            'format': 'YYYY-MM-DD',
            'daysOfWeek': [
              'Sö',
              'Må',
              'Ti',
              'On',
              'To',
              'Fr',
              'Lö'
            ],
            'monthNames': [
              'Januari',
              'Februari',
              'Mars',
              'April',
              'Maj',
              'Juni',
              'Juli',
              'Augusti',
              'September',
              'Oktober',
              'November',
              'December',
            ],
            'firstDay': 1
          },
        });
    }
  },
  finalize() {
    if ($('.select2').length) {
      $('.select2').select2({
        placeholder: "Klicka för att välja intressen",
        language: {
          maximumSelected: function () {
            return "Du kan max välja 5 stycken";
          }
        },
        multiple: true,
        maximumSelectionLength: 5,
      });
    }
    // JavaScript to be fired on the add campaign page, after the init JS
    const previewFiles = () => {
      const preview = document.getElementById('preview');
      preview.innerHTML = '';
      const files = document.querySelector('input[type=file]').files;

      const readAndPreview = (file) => {
        if (/\.(jpe?g|mp4|png)$/i.test(file.name)) {
          const reader = new FileReader();

          reader.addEventListener('load', () => {
            const wrapper = document.createElement('div');
            wrapper.classList.add('w-1/2', 'px-2', 'mb-4', 'relative');

            const isVideo = /\.(mp4)$/i.test(file.name);
            if (isVideo) {
              console.log();
              const video = document.createElement('video');
              video.classList.add('h-32', 'w-full', 'object-cover');
              video.src = window.URL.createObjectURL(file);
              wrapper.appendChild(video);

              const videoIcon = document.createElement('i');
              videoIcon.classList.add('material-icons', 'absolute', 'top-1/2', 'left-1/2', 'transform', '-translate-x-1/2', '-translate-y-1/2', 'text-white', 'bg-black', 'p-4', 'rounded-full');
              videoIcon.innerHTML = 'movie';
              wrapper.appendChild(videoIcon);
            } else {
              const image = document.createElement('div');
              image.classList.add('h-32', 'bg-cover', 'bg-center');
              image.style.backgroundImage = isVideo ? 'url(/wp-content/themes/wakai/images/video-placeholder.jpg)' : 'url(' + reader.result + ')';
              wrapper.appendChild(image);
            }

            preview.appendChild(wrapper);
          }, false);

          reader.readAsDataURL(file);
        }
      }

      if (files) {
        [].forEach.call(files, readAndPreview);
      }
    }

    const input = document.getElementById('media');
    if (input) {
      input.addEventListener('change', previewFiles);
    }
    const calculateFollowers = () => {
      const amountInput = document.getElementById('amount');
      if (amountInput && parseInt(amountInput.value) > 0) {
        let price_per_follower = 0.6; // The price that customer pays Wakai
        const totalFollowers = parseInt(amountInput.value) / price_per_follower;
        const followersElement = document.querySelector('#number_followers');
        if (followersElement) {
          followersElement.textContent = Math.floor(totalFollowers, 0);
        }
      }
    }

    const campaignForm = document.getElementById('campaign-form');
    if (campaignForm) {
      campaignForm.addEventListener('submit', function () {
        const message = document.getElementById('form-save');
        message.classList.remove('hidden');
      });
    }

    const amountInput = document.getElementById('amount');
    if (amountInput) {
      amountInput.addEventListener('change', function () {
        calculateFollowers();
      });
    }
    calculateFollowers();

  },
};
